import { loadMathJax } from './mathJaxLoader';
import { loadMarkdownUrl } from './markDowLoader';

// Export individual loaders
export { loadMathJax } from './mathJaxLoader';
export { loadMarkdownUrl } from './markDowLoader';

// Export combined loader that loads both MathJax and Markdown
export const loadMathMlDependencies = () => Promise.all([
  loadMathJax(),
  loadMarkdownUrl()
]);

